import React from "react";
import { useHistory, Link } from "react-router-dom"
import classnames from "classnames";

import SweetAlert from "react-bootstrap-sweetalert";

// reactstrap components
import {
  Button,
  Card, 
  CardHeader, 
  CardBody, 
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col
} from "reactstrap";

import { UserProfile } from "sessions/userState.js"
import { SessionConfigs } from "sessions/sessionState.js"
import { extractWorldInfo } from "sessions/gameInfo.js"
import { useHuntTrackerContext } from "tracker-context";

import { dataCenters } from "sessions/resources/datacenters.js";
import { textSelector } from "assets/selector/language.js"

import { 
  Divider,
} from "@mui/material";
import LanguageDependentText from "components/TimerTable/LanguageDependentText";

import axios from "axios";

const Register = () => {
  const history = useHistory();
  const [controller, dispatch] = useHuntTrackerContext();
  const { darkMode, language, user } = controller;

  if (user.profile_src) {
    history.push("/timer");
  }

  const textLibrary = SessionConfigs.dictionaryLookup;
  const [authenticationInfo, setAuthenticationInfo] = React.useState({username: "", password: "", ingameName: "", ingameServer: "Adamantoise", ingameID: ""});
  const [alert, setAlert] = React.useState(null);

  const [state, setState] = React.useState({});
  React.useEffect(() => {
    document.body.classList.toggle("login-page");
    return function cleanup() {
      document.body.classList.toggle("login-page");
    };
  });

  const handleUsernameChange = (event) => {
    setAuthenticationInfo({...authenticationInfo, username: event.target.value});
  }

  const handlePasswordChange = (event) => {
    setAuthenticationInfo({...authenticationInfo, password: event.target.value});
  }

  const handleWorldChange = (event) => {
    setAuthenticationInfo({...authenticationInfo, ingameServer: event.target.value});
  }

  const handleIngameNameChange = (event) => {
    setAuthenticationInfo({...authenticationInfo, ingameName: event.target.value});
  }

  const handleIngameIDChange = (event) => {
    setAuthenticationInfo({...authenticationInfo, ingameID: event.target.value});
  }

  const handleRegistration = () => {
    setAlert(
      <SweetAlert
          style={{display: "block",marginTop: "-100px"}}
          showCancel={false} showConfirm={false} showCloseButton={false}
          onConfirm={()=>{}} s
          title={textSelector.accountProcessing[language]}>
      </SweetAlert>);

    SessionConfigs.register(authenticationInfo).then((response) => {
      setAlert(null);

      UserProfile.setUser(response.data.user);
      dispatch({type: "User", value: UserProfile.getUser()});
      history.push("/timer");
      
    }).catch((error) => {
      setAlert(null);

      if (error.response.status == 403) {
        if (error.response.data.code) {
          setAlert(
            <SweetAlert
                error style={{display: "block",marginTop: "-100px"}}
                title="Error Received" onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
            {textSelector.accountErrors[error.response.data.code][language]}
          </SweetAlert>);
        }
      }
    })
  }

  return (
    <>
      <div className="content">
        {alert}
        <Container>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form">
              <Card className="card-white">
                <CardHeader>
                  <div className="bg-gradient-info shadow-info border-radius-lg py-3 pe-1" style={{transform: "translate(0%, -50%)"}}>
                    <LanguageDependentText variant="h4" header={"accountSignUp"} align="center" className="text-white font-weight-bolder text-center mt-2 mb-0"/>
                  </div>
                </CardHeader>
                <CardBody>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.emailFocus
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa-solid fa-user"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder={textLibrary("header","accountUsername")}
                      type="text"
                      value={authenticationInfo.username}
                      onFocus={(e) => setState({ ...state, emailFocus: true })}
                      onBlur={(e) => setState({ ...state, emailFocus: false })}
                      onChange={handleUsernameChange}
                    />
                  </InputGroup>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.passFocus
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa-solid fa-key"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder={textLibrary("header","accountPassword")}
                      type="password"
                      value={authenticationInfo.password}
                      onFocus={(e) => setState({ ...state, passFocus: true })}
                      onBlur={(e) => setState({ ...state, passFocus: false })}
                      onChange={handlePasswordChange}
                    />
                  </InputGroup>
                  <Divider> {textLibrary("header","accountIngameInfo")} </Divider>
                  
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.ingameNameFocus
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa-solid fa-person"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder={textLibrary("header","accountIngameName")}
                      type="text"
                      value={authenticationInfo.ingameName}
                      onFocus={(e) => setState({ ...state, ingameNameFocus: true })}
                      onBlur={(e) => setState({ ...state, ingameNameFocus: false })}
                      onChange={handleIngameNameChange}
                    />
                  </InputGroup>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.ingameWorldFocus
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa-solid fa-server"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="select" onChange={handleWorldChange}>
                      {Object.keys(dataCenters).map((dc) => {
                        const worlds = dataCenters[dc];
                        const worldSelects = worlds["Names"].map((world)=>{
                          return <option key={world} value={world}> {world} </option>
                        });

                        return [
                          <option key={dc} value={dc} disabled> --- {dc} --- </option>,
                          ...worldSelects
                        ]
                      })}
                    </Input>
                  </InputGroup>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.ingameIDFocus
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa-solid fa-person"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder={textLibrary("header","accountIngameID")}
                      type="text"
                      value={authenticationInfo.ingameID}
                      onFocus={(e) => setState({ ...state, ingameIDFocus: true })}
                      onBlur={(e) => setState({ ...state, ingameIDFocus: false })}
                      onChange={handleIngameIDChange}
                    />
                  </InputGroup>

                </CardBody>
                <CardFooter>
                  <Button
                    block
                    className="mb-3"
                    color="primary"
                    onClick={handleRegistration}
                    size="lg"
                  >
                    {textLibrary("header","profileSignup")}
                  </Button>
                  <div className="pull-left">
                    <h6>
                      <Link to="/login"
                        className="link footer-link"
                      >
                        {textLibrary("header","profileSignin")}
                      </Link>
                    </h6>
                  </div>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default Register;
